let getAssessmentHistoryObj = (theme) => {
  return {
    loadingCoverageStyle: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    loadinText: {
      fontSize: "14px",
      color: theme.textColour?.textTertiary || "#000",
      fontWeight: 400,
      lineHeight: "22px",
      letterSpacing: ".5px",
    },
    headerStyle: {
      display: "flex",
      alignItems: "center",
    },
    backToPatientsListStyle: {
      display: "flex",
      alignItems: "center",
    },
    patientInfoStyle: {
      marginY: "40px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    buttonStyle: (isMobile) => ({
      padding: isMobile ? "8px 12px" : "10px 20px",
      backgroundColor: "#0D47A1",
      marginTop: isMobile ? "20px" : "0px",
    }),
    tabPanelStyle: {
      marginY: "20px",
    },
    assessmentHistoryText: {
      marginY: "20px",
      fontWeight: "bold",
    },
    assessmentChipStyle: {
      marginTop: "10px",
      backgroundColor: "#FAB509",
    },
    cardStyle: (isMobile) => ({
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: isMobile ? "flex-start" : "center",
      backgroundColor: "white",
      border: "1px solid #0304041A",
      borderRadius: "8px",
      padding: "24px",
      marginY: "5px",
    }),
    expiresInStyle: {
      color: "#BF360C",
    },
    buttonOutlinedStyle: (isMobile) => ({
      padding: "8px 22px",
      marginTop: isMobile ? "10px" : "0px",
    }),
    noAssessmentBox: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignContent: "center",
      height: "100%",
      padding: "10%",
    },
    noAssessmentInnerBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexFlow: "column",
    },
    subjectIconBox: {
      backgroundColor: "#0D47A1",
      paddingX: "8px",
      pt: "8px",
      pb: "4px",
      borderRadius: "4px",
      width: "fit-content",
      mb: "20px",
    },
  };
};

export const getAssessmentHistoryStyle = getAssessmentHistoryObj;
